import ZonesAdmin from '@/features/Zones/views/ZonesAdmin.vue';
import permissions from '@Share/config/permissions';

// Company > Zones (AVA-181): every zone of the facilities and facility groups the user can open.
// The facility admin's Zones page (admin.routes.js) shows one facility's zones with plan drawing.
export default [
  {
    path: '/manage-zones',
    name: 'company-zones',
    component: ZonesAdmin,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Zones',
      permissions: [permissions.Zones.View],
    },
  },
];
